// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"129a2d5a","488":"481e10a7"}[chunkId] + ".chunk.js";
};